import { useContext } from "react";
import WebplaceContext from "../../../store/webplace-context";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TikTok from "../../../assets/mainItems/tiktokLogo.svg";
import PoweredHubster from "../../../assets/mainItems/poweredHubster.svg";
import PoweredOtter from "../../../assets/mainItems/poweredOtter.svg";


import "./Footer.css";

const splitString = (data) => {
  return data.split("/");
};

const Footer = () => {
  const footerLocationsCtx =
    useContext(WebplaceContext).locationInformation.locations;
  const footerInfoCtx = useContext(WebplaceContext).footerInformation;
  const contactCtx = useContext(WebplaceContext).homeSocials;
  const stylesCtx = useContext(WebplaceContext).footerInformation.footer_styles;

  const address = splitString(footerLocationsCtx[0].address);
  const schedule = splitString(footerLocationsCtx[0].schedule);
  const phone = footerLocationsCtx[0].phone;
  let poweredBy;

  if (footerInfoCtx.powered_by_hubster === footerInfoCtx.powered_by_otter) {
    poweredBy = <></>;
  } else if (
    footerInfoCtx.powered_by_hubster &&
    !footerInfoCtx.powered_by_otter
  ) {
    poweredBy = (
      <img src={PoweredHubster} alt="Powered by" className="powered-by" />
    );
  } else {
    poweredBy = (
      <img src={PoweredOtter} alt="Powered by" className="powered-by" />
    );
  }

  return (
    <div
      className="footer-wrapper"
      style={{
        backgroundColor: stylesCtx.background_color,
        color: stylesCtx.subtitle_font_color,
      }}
      aria-label="footer"
    >
      <div className="footer-title" role="heading" aria-level="2">{footerInfoCtx.title}</div>
      <div className="footer-info-wrapper">
        {/* Locations and address */}
        {footerLocationsCtx.length === 1 && (
          <div className="info-wrapper">
            <div className="info-title" role="heading" aria-level="3">{footerInfoCtx.address_subtitle}</div>
            {address.map((data, index) => {
              return (
                <div
                  className="info-data"
                  style={{ color: stylesCtx.info_font_color }}
                  key={index}
                >
                  {data}
                </div>
              );
            })}
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(footerLocationsCtx[0].address)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="location-map-link"
              aria-label={`View ${footerLocationsCtx[0].location_title || 'our location'} on Google Maps. Address: ${footerLocationsCtx[0].address.replace(/\//g, '')}`}
              style={{ color: stylesCtx.info_font_color }}
            >
              View on Google Maps
            </a>
          </div>
        )}
        {footerLocationsCtx.length > 1 && (
          <div className="locations-container" role="region" aria-labelledby="locations-heading">
            <div 
              className="info-title" 
              role="heading" 
              aria-level="3"
              id="locations-heading"
            >
              {footerInfoCtx.locations_subtitle}
            </div>
            <div 
              className="locations-grid" 
              role="list" 
              aria-label="Restaurant locations"
            >
              {footerLocationsCtx.map((data, index) => {
                const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(data.address)}`;
                return (
                  <div
                    className="location-column"
                    key={index}
                    role="listitem"
                    aria-labelledby={`location-title-${index}`}
                  >
                    <div className="location-info">
                      <div 
                        className="location-title"
                        id={`location-title-${index}`}
                        role="heading"
                        aria-level="4"
                      >
                        {data.location_title}
                      </div>
                      <div 
                        className="location-address"
                        aria-label={`Address: ${data.address.replace(/\//g, '')}`}
                      >
                        {data.address.replace(/\//g, '')}
                      </div>
                    </div>
                    <a
                      href={googleMapsUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="location-map-link"
                      aria-label={`View ${data.location_title} location on Google Maps. Address: ${data.address.replace(/\//g, '')}`}
                      aria-describedby={`location-title-${index}`}
                      style={{ color: stylesCtx.info_font_color }}
                    >
                      View on Google Maps
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Schedule */}
        {footerLocationsCtx.length === 1 && (
          <div>
            <div className="info-title" role="heading" aria-level="3">{footerInfoCtx.hours_subtitle}</div>
            {schedule.map((data, index) => {
              return (
                <div
                  className="info-data"
                  style={{ color: stylesCtx.info_font_color }}
                  key={index}
                >
                  {data}
                </div>
              );
            })}
          </div>
        )}

        {/* Contact information */}
        {footerInfoCtx.show_contact_option && (
          <div>
            <div className="info-title" role="heading" aria-level="3">
              {footerInfoCtx.contact_info_subtitle}
            </div>
            {footerLocationsCtx.length === 1 && (
              <a
                className="info-data"
                style={{ color: stylesCtx.info_font_color }}
                href={`tel: ${phone}`}
              >
                <div
                  className="info-data"
                  style={{ color: stylesCtx.info_font_color }}
                >
                  {phone}
                </div>
              </a>
            )}
            <div
              className="info-data"
              style={{ color: stylesCtx.info_font_color }}
            >
              {contactCtx.contact_email}
            </div>
          </div>
        )}

        {/* Social media & powered by */}
        <div className="socials-powered-wrapper">
          <div className="social-media-wrapper">
            {contactCtx.instagram_url.length > 0 && (
              <div>
                <a
                  href={contactCtx.instagram_url}
                  target="_self"
                  rel="noopener noreferrer"
                  className="anchor-social"
                >
                  <InstagramIcon fontSize="inherit" />
                </a>
              </div>
            )}
            {contactCtx.facebook_url.length > 0 && (
              <div>
                <a
                  href={contactCtx.facebook_url}
                  target="_self"
                  rel="noopener noreferrer"
                  className="anchor-social"
                >
                  <FacebookIcon fontSize="inherit" />
                </a>
              </div>
            )}
            {contactCtx.tiktok_url.length > 0 && (
              <div>
                <a
                  href={contactCtx.tiktok_url}
                  target="_self"
                  rel="noopener noreferrer"
                  className="anchor-social"
                >
                  <img
                    src={TikTok}
                    alt="tiktok"
                    className="anchor-social-img"
                  />
                </a>
              </div>
            )}
          </div>
          <div className="powered-by-wrapper">
            {poweredBy}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
